import { Dialog } from "@headlessui/react";
import { useTranslation } from "react-i18next";
import { Button } from "./button";
import type { TransNamespace } from "../types";

export type PriceChangedDialogProps = {
  oldPrice: string;
  newPrice: string;
  open: boolean;
  onContinue?: () => void;
  onClose?: () => void;
};

export const PriceChangedDialog = (props: PriceChangedDialogProps) => {
  const {
    oldPrice,
    newPrice,
    open,
    onClose = () => {},
    onContinue = () => {},
  } = props;
  const { t } = useTranslation<TransNamespace>("esim:price-changed-dialog");

  const handleContinue = () => {
    onContinue();
    onClose();
  };

  return (
    <Dialog open={open} onClose={onClose}>
      <div className="fixed inset-0 grid place-items-center bg-black/60 p-3">
        <Dialog.Panel className="grid max-w-lg rounded-md bg-white p-9 text-center">
          <Dialog.Description className="px-2 text-xl">
            {t(
              "Please note the price of the plan selected has changed, from {{oldPrice}} to {{newPrice}}.",
              { oldPrice, newPrice },
            )}
          </Dialog.Description>

          <Button
            className="mt-9 md:w-60 md:justify-self-center"
            color="primary"
            onClick={handleContinue}
          >
            {t("Continue")}
          </Button>

          <p className="mt-6 text-xs text-slate-700">
            {t(
              "The change is done in accordance with Mozio's T&C due to currency conversion.",
            )}
          </p>
        </Dialog.Panel>
      </div>
    </Dialog>
  );
};
